var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _positions;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import uniqueId from 'lodash/uniqueId';
import TetherComponent from 'react-tether';

import './RadarAnimation.scss';

var BOTTOM_CENTER = 'bottom-center';
var BOTTOM_LEFT = 'bottom-left';
var BOTTOM_RIGHT = 'bottom-right';
var MIDDLE_CENTER = 'middle-center';
var MIDDLE_LEFT = 'middle-left';
var MIDDLE_RIGHT = 'middle-right';
var TOP_CENTER = 'top-center';
var TOP_LEFT = 'top-left';
var TOP_RIGHT = 'top-right';

var positions = (_positions = {}, _defineProperty(_positions, BOTTOM_CENTER, {
    attachment: 'top center',
    targetAttachment: 'bottom center'
}), _defineProperty(_positions, BOTTOM_LEFT, {
    attachment: 'top left',
    targetAttachment: 'bottom left'
}), _defineProperty(_positions, BOTTOM_RIGHT, {
    attachment: 'top right',
    targetAttachment: 'bottom right'
}), _defineProperty(_positions, MIDDLE_CENTER, {
    attachment: 'middle center',
    targetAttachment: 'middle center'
}), _defineProperty(_positions, MIDDLE_LEFT, {
    attachment: 'middle right',
    targetAttachment: 'middle left'
}), _defineProperty(_positions, MIDDLE_RIGHT, {
    attachment: 'middle left',
    targetAttachment: 'middle right'
}), _defineProperty(_positions, TOP_CENTER, {
    attachment: 'bottom center',
    targetAttachment: 'top center'
}), _defineProperty(_positions, TOP_LEFT, {
    attachment: 'bottom left',
    targetAttachment: 'top left'
}), _defineProperty(_positions, TOP_RIGHT, {
    attachment: 'bottom right',
    targetAttachment: 'top right'
}), _positions);

var bpfrpt_proptype_Position = function bpfrpt_proptype_Position() {
    return (typeof $Keys === 'function' ? PropTypes.instanceOf($Keys) : PropTypes.any).apply(this, arguments);
};

var RadarAnimation = function (_React$Component) {
    _inherits(RadarAnimation, _React$Component);

    function RadarAnimation() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RadarAnimation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadarAnimation.__proto__ || Object.getPrototypeOf(RadarAnimation)).call.apply(_ref, [this].concat(args))), _this), _this.radarAnimationID = uniqueId('radarAnimation'), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadarAnimation, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                constrainToScrollParent = _props.constrainToScrollParent,
                constrainToWindow = _props.constrainToWindow,
                position = _props.position;


            var constraints = [];
            if (constrainToScrollParent) {
                constraints.push({
                    to: 'scrollParent',
                    attachment: 'together'
                });
            }
            if (constrainToWindow) {
                constraints.push({
                    to: 'window',
                    attachment: 'together'
                });
            }

            var tetherPosition = positions[position];
            return React.createElement(
                TetherComponent,
                {
                    attachment: tetherPosition.attachment,
                    classPrefix: 'radar-animation',
                    constraints: constraints,
                    targetAttachment: tetherPosition.targetAttachment
                },
                React.cloneElement(React.Children.only(children), {
                    'aria-describedby': this.radarAnimationID
                }),
                React.createElement(
                    'div',
                    {
                        className: 'radar ' + className,
                        id: this.radarAnimationID
                    },
                    React.createElement('div', { className: 'radar-dot' }),
                    React.createElement('div', { className: 'radar-circle' })
                )
            );
        }
    }]);

    return RadarAnimation;
}(React.Component);

RadarAnimation.defaultProps = {
    constrainToScrollParent: false,
    constrainToWindow: true,
    position: MIDDLE_RIGHT
};
RadarAnimation.propTypes = {
    /** A React element to put the radar on */
    children: PropTypes.node.isRequired,

    /** A CSS class for the radar */
    className: PropTypes.string,

    /** Whether to constrain the radar to the element's scroll parent. Defaults to `false` */
    constrainToScrollParent: PropTypes.bool.isRequired,

    /** Whether to constrain the radar to window. Defaults to `true` */
    constrainToWindow: PropTypes.bool.isRequired,

    /** Where to position the radar relative to the wrapped component */
    position: function position() {
        return (typeof $Keys === 'function' ? PropTypes.instanceOf($Keys).isRequired : PropTypes.any.isRequired).apply(this, arguments);
    }
};


export default RadarAnimation;
import PropTypes from 'prop-types';
export { bpfrpt_proptype_Position };